import React, { useState } from "react";
import "../CustomCSS/Services.css";
import JsonData from "../data/data.json";

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);

  return (
    <>
      <section id="services" className="services-section">
        <h2 className="services-title">Services</h2>

        <div className="services-grid">
          {JsonData.Services.map((service, idx) => (
            <div className="service-card" key={idx}>
              <img
                src={service.imgSrc}
                alt={service.title}
                className="service-image"
              />

              <h3 className="service-title">{service.title}</h3>

              <button
                className="know-more-btn"
                onClick={() => setSelectedService(service)}
              >
                Know More
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* MODAL */}
      {selectedService && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedService(null)}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>{selectedService.title}</h3>
            <p>{selectedService.description}</p>

            <button
              className="close-btn"
              onClick={() => setSelectedService(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Services;
